import { MyExportsTable } from '@/components/MyExportsTable'
import { myExportsSearchSchema } from '@/hooks/queries/useExportJobs'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/_modules/crt/my-exports/')({
  component: MyExportsPage,
  validateSearch: (search) => myExportsSearchSchema.parse(search),
})

function MyExportsPage() {
  const navigate = Route.useNavigate()
  const search = Route.useSearch()

  return <MyExportsTable module="crt" search={search} navigate={navigate} />
}
